module.exports = "/images/vendor/flag-icon-css/flags/1x1/gg.svg?357e1e33666fb0844d0416d5b0879d57";